/**
 * Modalité d'entrée (LOT 5.5.1) — clavier ou pointeur ?
 *
 * La sidebar AUTO ne doit rester ouverte pour un focus que si ce focus vient
 * du CLAVIER. Un clic souris donne aussi le focus au lien cliqué : sans cette
 * distinction, la sidebar restait ouverte après navigation jusqu'à un clic
 * ailleurs (bug de recette LOT 5.5). `document.activeElement` ne dit pas
 * COMMENT l'élément a été focalisé — ce module, si.
 */

let current: 'pointer' | 'keyboard' = 'pointer'

window.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' || e.key.startsWith('Arrow')) current = 'keyboard'
}, true)
window.addEventListener('pointerdown', () => { current = 'pointer' }, true)

export function inputModality(): 'pointer' | 'keyboard' {
  return current
}
